import useSWR from 'swr';

import { fetchEndpointData } from '@utils/fetchEndpointData';

import type { ComplaintResponse, ComplaintsResponse } from './endpoints/ComplaintsEndpoint.types';

export type Complaint = ComplaintResponse;

export const COMPLAINTS_SWR_KEY = 'complaints';

export async function getComplaints(startDate: string, endDate: string): Promise<ComplaintsResponse> {
  const params = new URLSearchParams({ startDate, endDate });
  return fetchEndpointData<ComplaintsResponse>(`/api/v1/complaints?${params.toString()}`);
}

export function useComplaints(startDate: string | undefined, endDate: string | undefined) {
  return useSWR(startDate && endDate ? [COMPLAINTS_SWR_KEY, startDate, endDate] : null, () =>
    getComplaints(startDate!, endDate!),
  );
}
